import React from 'react';

import Chip, {ChipSize} from 'ui-library/chips/Chip';
import PaddedBorderedCell from 'ui-library/internal/PaddedBorderedCell';

function onRemove(): void {
  console.log('onRemove!');
}

function onClick(): void {
  console.log('onClick!');
}

const ChipGuidelines = (): JSX.Element => {
  const chipSizes = Object.values(ChipSize);
  const chipStyles = [
    {faded: false, negative: false},
    {faded: true, negative: false},
    {faded: false, negative: true},
    {faded: true, negative: true},
  ];
  const chipPropNames = [
    'Chip',
    'Chip + icon',
    'Chip with onRemove',
    'Chip with onClick',
    'Chip with href',
    'Chip with href, onClick',
    'Chip with onClick, onRemove, icon',
    'Chip with onClick, onRemove, svg icon',
    'Chip with tooltipTitle',
  ];
  const chipSizeProps = [
    chipSizes.map((size) => ({
      size,
      text: 'Potato Chip',
    })),
    chipSizes.map((size) => ({
      size,
      text: 'Potato Chip',
      icon: 'star',
    })),
    chipSizes.map((size) => ({
      size,
      text: 'Potato Chip',
      onRemove,
    })),
    chipSizes.map((size) => ({
      size,
      text: 'Potato Chip',
      onClick,
    })),
    chipSizes.map((size) => ({
      size,
      text: 'Potato Chip',
      href: 'http://google.com',
    })),
    chipSizes.map((size) => ({
      size,
      text: 'Potato Chip',
      onClick,
      href: 'http://google.com',
    })),
    chipSizes.map((size) => ({
      size,
      text: 'Potato Chip',
      icon: 'star',
      onRemove,
      onClick,
    })),
    chipSizes.map((size) => ({
      size,
      text: 'Potato Chip',
      icon: 'protein',
      onRemove,
      onClick,
    })),
    chipSizes.map((size) => ({
      size,
      text: 'Potato Chip',
      tooltipTitle: 'Ashu likes potatoes!',
    })),
  ];
  const chipStyleProps = [
    chipStyles.map(({faded, negative}) => ({
      faded,
      negative,
      size: ChipSize.SMALL,
      text: 'Potato Chip',
    })),
    chipStyles.map(({faded, negative}) => ({
      faded,
      negative,
      size: ChipSize.SMALL,
      text: 'Potato Chip',
      icon: 'star',
    })),
    chipStyles.map(({faded, negative}) => ({
      faded,
      negative,
      size: ChipSize.SMALL,
      text: 'Potato Chip',
      onRemove,
    })),
    chipStyles.map(({faded, negative}) => ({
      faded,
      negative,
      size: ChipSize.SMALL,
      text: 'Potato Chip',
      onClick,
    })),
    chipStyles.map(({faded, negative}) => ({
      faded,
      negative,
      size: ChipSize.SMALL,
      text: 'Potato Chip',
      href: 'http://google.com',
    })),
    chipStyles.map(({faded, negative}) => ({
      faded,
      negative,
      size: ChipSize.SMALL,
      text: 'Potato Chip',
      onClick,
      href: 'http://google.com',
    })),
    chipStyles.map(({faded, negative}) => ({
      faded,
      negative,
      size: ChipSize.SMALL,
      text: 'Potato Chip',
      icon: 'star',
      onRemove,
      onClick,
    })),
    chipStyles.map(({faded, negative}) => ({
      faded,
      negative,
      size: ChipSize.SMALL,
      text: 'Potato Chip',
      icon: 'protein',
      onRemove,
      onClick,
    })),
    chipStyles.map(({faded, negative}) => ({
      faded,
      negative,
      size: ChipSize.SMALL,
      text: 'Potato Chip',
      tooltipTitle: 'Ashu likes potatoes!',
    })),
  ];

  return (
    <div className="u-padding">
      <h1>Potato Chips</h1>
      <a href="https://zpl.io/aB1rDnA">Mocks: https://zpl.io/aB1rDnA</a>
      <div className="u-large-spacing-top">
        <p>Chips also have a focused state - click the gray background area of a chip to focus it.</p>
        <p>Look at the console log to see when events (onClick, onRemove) are fired.</p>
        <h3>Sizes</h3>
        <table>
          <thead>
            <tr>
              <PaddedBorderedCell>Chip</PaddedBorderedCell>
              <PaddedBorderedCell>Table Cell</PaddedBorderedCell>
              <PaddedBorderedCell>Mini</PaddedBorderedCell>
              <PaddedBorderedCell>Small</PaddedBorderedCell>
            </tr>
          </thead>
          <tbody>
            {chipSizeProps.map((chipPropRow, idx) => (
              <tr key={idx}>
                <PaddedBorderedCell>{chipPropNames[idx]}</PaddedBorderedCell>
                {chipPropRow.map((props, colIdx) => (
                  <PaddedBorderedCell key={colIdx}>
                    <Chip {...props} />
                  </PaddedBorderedCell>
                ))}
              </tr>
            ))}
            <tr>
              <PaddedBorderedCell>Multiple Chips</PaddedBorderedCell>
              {chipSizeProps[0].map((props, colIdx) => (
                <PaddedBorderedCell key={colIdx}>
                  <Chip {...props} />
                  <Chip {...props} />
                  <Chip {...props} />
                </PaddedBorderedCell>
              ))}
            </tr>
          </tbody>
        </table>
        <h3>Styles</h3>
        <table>
          <thead>
            <tr>
              <PaddedBorderedCell>Chip</PaddedBorderedCell>
              <PaddedBorderedCell>Default</PaddedBorderedCell>
              <PaddedBorderedCell>Faded</PaddedBorderedCell>
              <PaddedBorderedCell>Negative</PaddedBorderedCell>
              <PaddedBorderedCell>Faded and Negative</PaddedBorderedCell>
            </tr>
          </thead>
          <tbody>
            {chipStyleProps.map((chipPropRow, idx) => (
              <tr key={idx}>
                <PaddedBorderedCell>{chipPropNames[idx]}</PaddedBorderedCell>
                {chipPropRow.map((props, colIdx) => (
                  <PaddedBorderedCell key={colIdx}>
                    <Chip {...props} />
                  </PaddedBorderedCell>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ChipGuidelines;
